import { Injectable } from "@angular/core";
import { Reprise } from "src/app/domain/Qualif/reprise";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { RepriseEntity } from "../reprise.entity";
import { PrelevementQualifSalleEntity } from "../prelevement-qualif-salle.entity";
import * as _ from 'lodash'

@Injectable({
    providedIn: 'root',
})
export class RepriseRepository {
    constructor() { }
    async getRepriseEntityByCode(code: string) {
        return await db.reprises.where('Code').equals(code).first(async me => {
            return me;
        });
    }

    async getRepriseEntityById(id: number) {
        return await db.reprises.where('Id').equals(id).first(async se => {
            return se;
        });
    }

    async getRepriseById(id: number) {
        return await db.reprises.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, RepriseEntity, Reprise)

            return z;
        });
    }

    async attachReprise(ps: Reprise, prelevementQualifSalleEntity: PrelevementQualifSalleEntity) {
        let reId: number;
        const re = mapper.map(ps, Reprise, RepriseEntity);

        // const qse = await this.qualifSalleRepository.getQualifSalleEntityById(qualifSalleId);
        re.Id = await db.reprises.add(re);
        prelevementQualifSalleEntity.RepriseIds = prelevementQualifSalleEntity?.RepriseIds ? [...prelevementQualifSalleEntity.RepriseIds, re.Id] : [re.Id]
        await db.prelevementQualifSalles.update(prelevementQualifSalleEntity.Id!, {
            RepriseIds: prelevementQualifSalleEntity?.RepriseIds
        });

        return re.Id;
    }

    async updateReprise(r: Reprise) {

        const re = await this.getRepriseEntityByCode(r.Code)
        if (re && re.Id) {
            mapper.mutate(r, re, Reprise, RepriseEntity);
            await db.reprises.update(re.Id, r);
        }
    }

    async deleteRepriseById(id: number, prelevementQualifSalleEntity: PrelevementQualifSalleEntity) {
        await db.reprises.where('Id').equals(id).delete();

        // const oe = await this.prelevementRepository.getPrelevementEntityByCode(prel.Code);
        if (prelevementQualifSalleEntity && prelevementQualifSalleEntity.Id) {
            _.remove(prelevementQualifSalleEntity.RepriseIds, x => x === id)
            await db.prelevementQualifSalles.update(prelevementQualifSalleEntity.Id, {
                RepriseIds: prelevementQualifSalleEntity.RepriseIds
            });
        }
    }
}